import React from "react";
import {LastOrdersWidget, LastErrorsWidget, AdvanceTablesWidget1, MixedWidget6, MixedWidget10, MixedWidget11, MixedWidget12, TilesWidget1, TilesWidget3, TilesWidget10, ProductsTileWidget, UsersTileWidget, TilesWidget13, TilesWidget14} from "../widgets";

export function AdminDashboard() {
    return <>
        {/* begin::Dashboard */}
        
        {/* begin::Row */}
        <div className="row">
            <div className="col-lg-4 col-xl-4 col-xxl-4">
                <MixedWidget6 className="gutter-b card-stretch" chartColor="danger"/>
            </div>
            <div className="col-xl-8">
                <div className="row">
                    <div className="col-xl-6">
                        <div className="row">
                            <div className="col-xl-6">
                                <ProductsTileWidget className="gutter-b" baseColor="primary" widgetHeight="150px"/>
                            </div>
                            <div className="col-xl-6">
                                <UsersTileWidget className="gutter-b" iconColor="success" widgetHeight="150px"/>
                            </div>
                            <div className="col-lg-12">
                                <LastOrdersWidget className="card-stretch gutter-b"/>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <LastErrorsWidget className="card-stretch gutter-b"/>
                    </div>

                </div>

            </div>

        </div>
    </>;
}
